export const NYP_SITE = { url: "https://nahyoupick.com", label: "nahyoupick.com" }
export const RODG_SITE = { url: "https://rideordieguide.com", label: "rideordieguide.com" }
